<div class="event-cart">
  {#if data}
    <div class="avatar" style="background-image: url({data.src})"></div>
  {/if}
  <div class="content">
    <slot></slot>
  </div>
</div>

<style>
  .event-cart {
    max-width: 500px;
    padding: 50px 45px;
    background: white;
    margin: 0 auto 3.125rem auto;
    .avatar {
      width: 50px;
      height: 50px;
      background-size: cover;
      border-radius: 100%;
      margin-bottom: 15px;
    }
    .content {
      :global(div) {
        line-height: 25px;
        font-size: 16px;
        color: #676D79;
        margin-bottom: 10px;
      }
      :global(p) {
        line-height: 35px;
        font-size: 13px;
        letter-spacing: 0.05em;
        text-transform: uppercase;
        color: #000000;
        margin-bottom: 0!important;
      }
    }
  }
</style>
